import type z from 'zod/v4'
import { relations, sql } from 'drizzle-orm'
import { index, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core'
import { createInsertSchema, createSelectSchema, createUpdateSchema } from 'drizzle-zod'

import { user } from '../auth'

export const MyBookCollectionOrder = pgTable(
  'my_book_collection_order',
  {
    id: uuid().primaryKey().defaultRandom(),
    userId: text()
      .notNull()
      .references(() => user.id, { onDelete: 'cascade' }),
    order: text('order').notNull(),
    createdAt: timestamp({ mode: 'date', withTimezone: true }).defaultNow().notNull(),
    updatedAt: timestamp({ mode: 'date', withTimezone: true }).$onUpdateFn(() => sql`now()`),
  },
  (table) => [index('idx_my_book_collection_order_user').on(table.userId)],
)

export const myBookCollectionOrderRelations = relations(MyBookCollectionOrder, ({ one }) => ({
  user: one(user, {
    fields: [MyBookCollectionOrder.userId],
    references: [user.id],
  }),
}))

export const InsertMyBookCollectionOrderSchema = createInsertSchema(MyBookCollectionOrder).omit({
  id: true,
  createdAt: true,
  updatedAt: true,
})

export const UpdateMyBookCollectionOrderSchema = createUpdateSchema(MyBookCollectionOrder).partial().omit({
  id: true,
  userId: true,
  createdAt: true,
  updatedAt: true,
})

export const SelectMyBookCollectionOrderSchema = createSelectSchema(MyBookCollectionOrder)

export type InsertMyBookCollectionOrder = typeof MyBookCollectionOrder.$inferInsert
export type UpdateMyBookCollectionOrder = z.infer<typeof UpdateMyBookCollectionOrderSchema>
export type SelectMyBookCollectionOrder = typeof MyBookCollectionOrder.$inferSelect
